<template>
  <HeaderTrade/> 
  <!-- Container Start { -->
  <div id="container">
    <!-- Contents Start { -->
    <div id="contents">
      
      <div class="policy-box">
        <Privacy/>
      </div>

    </div>
    <!-- } Contents End -->

  </div>
  <!-- } Container End -->
  <Footer/>
</template>

<script>

import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import Footer from '@/components/Footer.vue';
import Privacy from '@/components/terms/Privacy.vue';

export default {
  components:{  
  HeaderTrade, 
  Footer,
  Privacy,
},
  setup(){
    const store = useStore();
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_privacy'); 
    store.commit('common/CHANGE_CURRENT_PAGE', 'Privacy');
    return {      

    }
  }
}
</script>

<style>

</style>